import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import classes from "./MarkdownContent.module.scss";
import { lineBreaks } from "./plugins/line-breaks";

export function MarkdownContent({ children, className, ...props }) {
  const rootClasses = cx(classes.root, className);
  return (
    <ReactMarkdown
      className={rootClasses}
      {...props}
      remarkPlugins={[lineBreaks, remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  );
}

MarkdownContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  ...ReactMarkdown.propTypes,
};

MarkdownContent.defaultProps = {
  className: undefined,
  ...ReactMarkdown.defaultProps,
};
